import React from 'react';
import withIcon from '../utilities/withIcon';

const IconPlusCircle = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm0 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm0 2a.75.75 0 0 1 .75.75v3h3a.75.75 0 1 1 0 1.5h-3v3a.75.75 0 1 1-1.5 0v-3h-3a.75.75 0 0 1 0-1.5h3v-3A.75.75 0 0 1 8 3.5z" />
    </g>
  );
};

export default withIcon(IconPlusCircle);
